import React from 'react';
import { FaFilePdf, FaDownload, FaLock } from 'react-icons/fa';
import './DownloadCard.css';

const DownloadCard = ({ title, description, buttonText, link, answerKeyLink, answerKeyText }) => {
  if (!link) return null;

  const isAuthenticated = !!localStorage.getItem('accessToken');

  return (
    <div className="download-card">
      <div className="download-card-icon-container">
        <div className="download-card-icon-wrapper">
          <FaFilePdf className="download-pdf-icon" />
          <span className="download-badge">PDF</span>
        </div>
      </div>
      <div className="download-card-info">
        <h4 className="download-card-title">{title}</h4>
        <p className="download-card-description">{description}</p>
        {!isAuthenticated && (
          <p className="login-to-download-text" style={{ color: '#e53e3e', fontSize: '12px', fontWeight: '600', marginTop: '6px', display: 'flex', alignItems: 'center', gap: '4px' }}>
            <FaLock size={11} />
            <span>लॉग इन करा - डाऊनलोड करण्यासाठी लॉग इन करणे आवश्यक आहे. (Please sign in to download).</span>
          </p>
        )}
      </div>
      <div className="download-card-action">
        {isAuthenticated ? (
          <a 
            href={link} 
            download
            target="_blank" 
            rel="noopener noreferrer" 
            className="download-card-btn"
          >
            <FaDownload className="download-btn-icon" />
            <span>{buttonText || 'Download PDF'}</span>
          </a>
        ) : (
          <a 
            href="/signin" 
            className="download-card-btn"
            style={{ background: 'linear-gradient(135deg, #e53e3e, #f56565)', boxShadow: '0 4px 12px rgba(229, 62, 62, 0.25)' }}
          >
            <FaLock className="download-btn-icon" />
            <span>{buttonText || 'Download PDF'}</span>
          </a>
        )}
        {answerKeyLink && (
          answerKeyLink === 'coming_soon' ? (
            <span 
              className="download-card-btn download-key-btn"
              style={{
                background: '#f7fafc',
                color: '#a0aec0',
                borderColor: '#e2e8f0',
                cursor: 'not-allowed',
                boxShadow: 'none',
                pointerEvents: 'none',
                opacity: 0.7
              }}
            >
              <span>{answerKeyText || 'Available Soon'}</span>
            </span>
          ) : isAuthenticated ? (
            <a 
              href={answerKeyLink} 
              download
              target="_blank" 
              rel="noopener noreferrer" 
              className="download-card-btn download-key-btn"
            >
              <FaDownload className="download-btn-icon" />
              <span>{answerKeyText || 'Answer Key'}</span>
            </a>
          ) : (
            <a 
              href="/signin" 
              className="download-card-btn download-key-btn"
              style={{ color: '#e53e3e', borderColor: '#e53e3e' }}
              onMouseEnter={(e) => {
                e.target.style.background = '#fff5f5';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'white';
              }}
            >
              <FaLock className="download-btn-icon" style={{ color: '#e53e3e' }} />
              <span>{answerKeyText || 'Answer Key'}</span>
            </a>
          )
        )}
      </div>
    </div>
  );
};

export default DownloadCard;
